export const SET_QUESTIONS_THEMES = 'SET_QUESTIONS_THEMES';
export const SET_ERRORS = 'SET_ERRORS';
